import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
interface LandingPageProps {
  onCheckout?: () => void;
}
export function LandingPage({
  onCheckout
}: LandingPageProps) {
  return <main className="min-h-screen w-full bg-cream font-sans text-slate-800 selection:bg-gold/30 selection:text-navy" data-id="element-397">
      <HeroSection data-id="element-398" />
      <PainSection data-id="element-399" />
      <SolutionSection data-id="element-400" />
      <BenefitsSection data-id="element-401" />
      <OfferSection data-id="element-402" />
      <PricingSection onCheckout={onCheckout} data-id="element-403" />
      <FAQSection data-id="element-404" />
      <FinalCTA onCheckout={onCheckout} data-id="element-405" />
      <Footer data-id="element-406" />
    </main>;
}